<div class="main-window">
  <div class="login-box" fxLayout="column">
    <label class="system-name">{{title}}</label>

    <form *ngIf="loginState == 'client_credentials'" [formGroup]="userNameForm">
      <div fxLayout="column" fxLayoutGap="10px">
        <mat-card class="login-form">
          <mat-icon style="grid-row: 1; grid-column: 1; align-self: center">person</mat-icon>
          <mat-form-field style="grid-row: 1; grid-column: 2">
            <input matInput autocomplete="off" [placeholder]="'EURO.USER_NAME'| translate"
              formControlName="username"></mat-form-field>
              <div class="password-icon">
                <mat-icon >lock</mat-icon>
              </div>
              <mat-form-field style="grid-row: 2; grid-column: 2">
                <div class="password-input">
                  <input [class]="hidePassword ? 'password' : ''" matInput autocomplete="off"
                  [placeholder]="'EURO.PASSWORD'| translate" formControlName="password">
                  <mat-icon class="show-password" (click)="togglePassword()">{{ hidePassword ? 'visibility' : 'visibility_off' }}</mat-icon>
                </div>
              </mat-form-field>
        </mat-card>
        <label class="error-message">
          {{ userNameForm.errors?.noAdminServer ? ('ERRORS.NOT_AVAILABLE' | translate) :
          userNameForm.errors?.incorrectLogin ? ('ERRORS.LOGIN_INCORRENT' | translate) :
          userNameForm.errors?.adminServerTimeOut ? ('ERRORS.NO_RESPONSE' | translate) :
          userNameForm.errors?.incorrectUserName ? ('ERRORS.USERNAME_INCORRECT' | translate) :
          userNameForm.errors?.incorrectPassword ? ('ERRORS.PASSWORD_INCORRECT' | translate) : "&nbsp;"}}
        </label>
        <button *ngIf="!isLoading" mat-stroked-button (click)="onLoginClick($event)"
          [disabled]="!userNameForm.valid">{{'EURO.LOG_IN' | translate}}</button>
        <div class="middle-container">
          <app-spinninganimation *ngIf="isLoading"></app-spinninganimation>
        </div>
      </div>
    </form>
    <form *ngIf="loginState == 'mfa_otp'" [formGroup]="mfaForm">
      <div fxLayout="column" fxLayoutGap="10px">
        <mat-card class="login-form">
          <mat-icon style="grid-column: 1; align-self: center">lock</mat-icon>
          <mat-form-field style="grid-column: 2">
            <input matInput autocomplete="off" [placeholder]="'EURO.VERIFICATION_CODE'| translate"
              formControlName="code"></mat-form-field>
        </mat-card>
        <label class="error-message">
          {{ mfaForm.errors?.adminServerTimeOut ? ('ERRORS.NO_RESPONSE' | translate) : "&nbsp;" }}
        </label>
        <button *ngIf="!isLoading" mat-stroked-button (click)="onMfaLoginClick($event)"
          [disabled]="!mfaForm.valid">{{'Verify' | translate}}</button>
        <button *ngIf="!isLoading && loginState == 'mfa_otp'" mat-stroked-button (click)="changeLoginState()">
          {{'Back' | translate}}
        </button>
        <div class="middle-container">
          <app-spinninganimation *ngIf="isLoading"></app-spinninganimation>
        </div>
      </div>
    </form>
  </div>
  <div class="bottom-left-box"></div>
  <div class="top-right-box"></div>
</div>

<div class="version-tag">
  {{ver}}
</div>